<div>
  <app-job-tasks-list [job]='job()' [tasks]='tasks()' [(jobStartEnabled)]='jobStartEnabled'></app-job-tasks-list>
</div>
